$shm_hitalama_map_catalog $shm_hitalama_entity_catalog
	auto /
		^
		<= favorites_migration_auto null
		<= map_summaries_migration_auto null
	menu_title \Карты
	Help $shm_hitalama_guide_toggle
		section \maps
	maps_list_visible? true
	param \map
	title_default \Новая карта
	Page* $shm_hitalama_map_page
		entity <= entity*
	Book* $shm_hitalama_map_book
		entity <= entity*
	add_map* null
	menu_item_content* /$mol_view
		<= Menu_link*
		<= Favorite_action* $mol_view
			attr *
				^
				favorite <= map_favorite* false
			sub /
				<= Favorite* $mol_button_minor
					attr *
						^
						favorite <= map_favorite* false
					hint <= favorite_hint* \
					event_click? <=> favorite_toggle*? null
					sub /
						<= Favorite_icon* $mol_icon_star
		<= Editor_mode_action* $mol_view
			attr *
				^
				editor <= editor_mode_current* false
			sub /
				<= Editor_mode* $mol_link
					attr *
						^
						editor <= editor_mode_current* false
					hint \Открыть редактор
					sub /
						<= Editor_mode_icon* $mol_icon_code_braces
					arg <= editor_mode_link* *
	menu_link_content* /$mol_view_content
		^ map_title_content* /
	Menu_link* $mol_link
		arg <= menu_link_arg*
		sub <= menu_link_content*
		event *
			^
			dblclick? <=> map_rename_start*? null
	Map_title_input*0 $mol_string
		value? <=> map_title_draft*? \
		submit? <=> map_rename_submit*? null
		event *
			^
			pointerdown? <=> map_rename_pointerdown*? null
			click? <=> map_rename_click*? null
			blur? <=> map_rename_submit*? null
			keydown? <=> map_rename_keydown*? null
	Map_title*0 $mol_view
		sub /
			^ public_icon_visible* / <= Public_icon* $mol_icon_earth
				sub /
					^
					<= Public_hint* $mol_svg_title
						title <= public_hint* \
			<= Menu_link_title* $mol_dimmer
				needle <= menu_filter
				haystack <= spread_title*
	menu_body /
		<= Map_menu_links
	Map_menu_links $mol_view
		sub <= map_menu_links /$mol_view
	Owned_tree $shm_hitalama_dragtree
		drag_hold_delay 300
		drag_hold_move_threshold 10
		drag_touch_action \auto
		roots? <=> owned_tree_roots? /
		children*? <=> owned_tree_children*? /
		expanded*? <=> project_expanded*? true
		can_have_children* <= owned_tree_can_have_children* false
		can_be_child* <= owned_tree_can_be_child* true
		item_height* <= owned_tree_item_height* 40
		Item* <= Owned_tree_item* $mol_view
	Project_item* $mol_view
		sub <= project_item_content* /
	Project_menu* $mol_pick
		align \right_bottom
		bubble_offset <= project_menu_offset* /
			0
			0
		bubble_align /number
			0
			0
		Anchor <= Project_title* $mol_check
			aria_role \button
			checked false
			clicks? <=> project_rename_start*? null
			sub /
				<= Project_icon* $mol_icon_folder
				<= Project_title_text* $mol_view
					sub / <= project_title* \Проект
		event *
			^
			contextmenu? <=> project_contextmenu*? null
		bubble_content /
			<= Project_menu_list* $mol_list
				sub <= project_menu_items* /
					<= Project_rename_action* $mol_button_minor
						click? <=> project_menu_rename*? null
						sub / \Переименовать
					<= Project_delete* $mol_button_minor
						hint \Удалить проект
						click? <=> project_delete*? null
						sub / \Удалить
	Project_delete_confirm* $mol_button_major
		title \Подтвердить удаление проекта
		click? <=> project_delete_confirm*? null
		sub / \Удалить
	Project_delete_cancel* $mol_button_minor
		title \Отменить удаление проекта
		click? <=> project_delete_cancel*? null
		sub / \Отмена
	Project_undo $mol_button_minor
		title \Вернуть удалённый проект
		click? <=> project_delete_undo? null
		sub / <= project_undo_title \Отменить удаление проекта
	Project_title_input*0 $mol_string
		value? <=> project_title_draft*? \
		submit? <=> project_rename_submit*? null
		event *
			^
			pointerdown? <=> project_rename_pointerdown*? null
			blur? <=> project_rename_submit*? null
			keydown? <=> project_rename_keydown*? null
	Visited_title $mol_text
		text \Посещённые карты:
	Available_title $mol_text
		text \Доступные карты:
	menu_head /$mol_view_content
		<= List_head $shm_list_head
			title <= menu_title
			add_content /
				<= Add_map $mol_pop_over
					align \bottom_right
					Anchor <= Add_map_anchor $mol_button_minor
						sub /
							<= Add_map_icon $mol_icon_plus
							\Добавить
					bubble_content /
						<= Add_map_menu $mol_list
							sub /
								<= Add_private $mol_button_minor
									click? <=> add_map*private? null
									sub /
										<= Add_private_icon $mol_icon_plus
										\Приватная карта
								<= Add_public $mol_button_minor
									click? <=> add_map*public_read? null
									sub /
										<= Add_public_icon $mol_icon_plus
										\Публичная карта
								<= Add_public_edit $mol_button_minor
									click? <=> add_map*public_edit? null
									sub /
										<= Add_public_edit_icon $mol_icon_plus
										\Публичная редактируемая карта
								<= Add_project $mol_button_minor
									click? <=> add_project? null
									sub /
										<= Add_project_icon $mol_icon_folder
										\Добавить проект
								<= Import $shm_hitalama_attach
									attach_title \Импорт из файла
									attach_new? <=> import? null
			close? <=> close_maps_list? null
			filter? <=> menu_filter? \
			sort_order? => sort_order?
			sort_by? <=> sort_by? \
